/**
 * Set the payment provider selected by the organization.
 * Could be `undefined` for organization without provider yet.
 */
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["STRIPE"] = "STRIPE";
})(PaymentProvider || (PaymentProvider = {}));
